function t(r) {
  return typeof r == "object" && r !== null && "id" in r;
}
const o = (r) => Array.isArray(r) && r.every((n) => typeof n == "object" && n !== null && "key" in n && "default" in n);
export {
  o as isParamArray,
  t as isZSLAssetWithZdl
};
//# sourceMappingURL=zslTypeguard.es.js.map
